import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[cvImageFallback]'
})
/**
 * Directive to display a new empty state in case the img cannot load from url
 */
export class ImageFallbackDirective {

  //path from svg icon
  @Input() svgIcon: string = "";
  //class or classes to add style on svg element
  @Input() svgClass: string = "";
  //span text
  @Input() spanText: string = "";
  //class or classes to add style on span element
  @Input() spanClass: string = "";
  //class or classes to add style on the paren div
  @Input() bgContainer: string = "bg-white";

  constructor(private _el: ElementRef, private _render: Renderer2) { }

  //listen error event on img tag 
  @HostListener('error')
  private errorHandler() {
    this.handleErrorLoad();
  }

  private handleErrorLoad() {
    //get the parent div
    const imgContainer = this._render.parentNode(this._el.nativeElement);
    this._render.addClass(imgContainer, this.bgContainer);
    //create svg element
    const svg = this._render.createElement('svg', 'svg');
    this._render.setAttribute(svg, 'class', this.svgClass);
    //create new use element and append to parent (svg)
    const use = this._render.createElement('use', 'svg');
    this._render.setAttribute(use, 'href', this.svgIcon);
    this._render.appendChild(svg, use);

    //span text
    const cannotLoadText = this._render.createText(this.spanText);

    //create span element
    const span = this._render.createElement('span');
    this._render.appendChild(span, cannotLoadText);
    this._render.setAttribute(span, 'class', this.spanClass);

    //replace img tag with new elements
    this._el.nativeElement.replaceWith(svg, span)
  }

}
